{
  "evaluationPublished": "La evaluación de {{respondentEmail}} está lista",
  "evaluationReady": "Tu evaluación de {{tenantName}} está lista",
  "selfProfileReady": "Tu perfil está listo para comenzar",
  "assignmentsSent": "Tus cuestionarios se han enviado",
  "creditsReady": "Tus créditos están listos",
  "aiProfilingReady": "El borrador de IA para {{respondentName}} está listo",
  "aiProfilingFailed": "No se pudo generar el borrador de IA para {{respondentName}}",
  "view": "Ver",
  "start": "Comenzar"
}
